<template>
  <div v-if="locktitle" class="unlock-section">
       <div class="img">
         <img :src="lockimage"  alt="Logo" />
       </div>
       <div class="img-content">
         <h4>{{ locktitle }}</h4>
          <span><b>Only {{ lockrate }}</b></span>
          <button @click="goToOfferLink(locklink)"  class="get-started">Explore Now</button>
       </div>
     </div>
</template>

<script setup>
import { defineProps } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();

const goToOfferLink = (locklink) => {
  router.push({ name: 'AncestryDetails', params: { slug: locklink } });
};
defineProps({
 locktitle: String,
 lockimage: String,
 locklink: [String, Number],
 lockrate:String
});

</script>
